import { Box, CircularProgress } from '@mui/material'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import type { PapelUsuario } from '@/contratos'
import { useAuth } from './AuthContext'

function Carregando() {
  return (
    <Box sx={{ display: 'grid', placeItems: 'center', minHeight: '100vh' }}>
      <CircularProgress />
    </Box>
  )
}

export function ExigeLogin() {
  const { usuario, carregando } = useAuth()
  const location = useLocation()

  if (carregando) return <Carregando />
  if (!usuario) return <Navigate to="/login" replace state={{ de: location.pathname }} />
  return <Outlet />
}

export function ExigePapel({ papeis }: { papeis: PapelUsuario[] }) {
  const { usuario, carregando } = useAuth()

  if (carregando) return <Carregando />
  if (!usuario) return <Navigate to="/login" replace />
  if (!papeis.includes(usuario.papel)) return <Navigate to="/auditorias" replace />
  return <Outlet />
}
